<template>
  <div class="wallet-bill-page">
    <div class="summary">
      <el-card class="summary-card" shadow="hover">
        <div class="summary-item">
          <div class="label">支出</div>
          <div class="value">￥{{ yuan(summary.expense) }}</div>
        </div>
      </el-card>
      <el-card class="summary-card" shadow="hover">
        <div class="summary-item">
          <div class="label">收入</div>
          <div class="value">￥{{ yuan(summary.income) }}</div>
        </div>
      </el-card>
    </div>
    <el-card class="bill-list" shadow="hover">
      <div slot="header" class="clearfix">
        <span>账单明细</span>
      </div>
      <div class="bill-scroll" @scroll="onScroll">
        <el-table :data="records" stripe size="small">
          <el-table-column prop="createTime" label="时间" width="180">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column label="类型" width="120">
            <template slot-scope="scope">
              {{ typeName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="120">
            <template slot-scope="scope">
              <span :class="scope.row.amount < 0 ? 'expense' : 'income'">
                {{ amountSign(scope.row.amount) }}￥{{ yuan(absAmount(scope.row.amount)) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="targetName" label="会话" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.targetName || '-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="list-footer">
          <span v-if="loadingMore">加载中...</span>
          <span v-else-if="finished">没有更多了</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WalletBill',
  data() {
    return {
      summary: { income: 0, expense: 0 },
      records: [],
      total: 0,
      size: 10,
      current: 1,
      pages: 0,
      loadingMore: false,
      finished: false
    }
  },
  methods: {
    yuan(cents) {
      return ((cents || 0) / 100).toFixed(2);
    },
    amountSign(val) {
      return val < 0 ? '-' : '+';
    },
    absAmount(val) {
      return Math.abs(val || 0);
    },
    formatTime(t) {
      try { return this.$date.toTimeText(new Date(t).getTime(), true) } catch(e) { return t }
    },
    typeName(row) {
      if (row && row.remark && row.remark.trim().length > 0) return row.remark;
      const t = row && row.type;
      if (t === 1) return '充值';
      if (t === 2) return '提现';
      if (t === 3) return '发红包';
      if (t === 4) return '领红包';
      return '-';
    },
    async init() {
      await this.loadSummary();
      await this.loadRecords(1, false);
    },
    async loadSummary() {
      try {
        const uid = await this.getUserId();
        if (!uid) return;
        const vo = await this.$http({ url: `https://chat.echat.my/api/wallet/summary?userId=${uid}`, method: 'GET' });
        this.summary.income = vo && typeof vo.income === 'number' ? vo.income : 0;
        this.summary.expense = vo && typeof vo.expense === 'number' ? vo.expense : 0;
      } catch (e) { let _ = e; }
    },
    async loadRecords(page, append) {
      try {
        const uid = await this.getUserId();
        if (!uid) return;
        const vo = await this.$http({ url: `https://chat.echat.my/api/wallet/transactions?userId=${uid}&page=${page}&size=${this.size}`, method: 'GET' });
        const data = vo || {};
        const list = Array.isArray(data.records) ? data.records : [];
        if (append) {
          this.records = this.records.concat(list);
        } else {
          this.records = list;
        }
        this.total = data.total || 0;
        this.size = data.size || this.size;
        this.current = data.current || page;
        this.pages = data.pages || Math.ceil((this.total || 0) / (this.size || 10));
        if (this.current >= this.pages || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      } catch (e) { let _ = e; }
    },
    async getUserId() {
      const id = this.userStore && this.userStore.userInfo && this.userStore.userInfo.id;
      if (id) return id;
      try {
        const vo = await this.$http({ url: 'https://chat.echat.my/api/user/self', method: 'GET' });
        const uid = vo && vo.id;
        if (uid) {
          try { this.userStore.setUserInfo(vo) } catch(e2) { let _ = e2; }
          return uid;
        }
      } catch(e1) { let _ = e1; }
      try {
        await this.userStore.loadUser();
        return (this.userStore.userInfo && this.userStore.userInfo.id) || null;
      } catch(e) {
        return null;
      }
    },
    async loadMore() {
      if (this.loadingMore || this.finished) return;
      const next = this.current + 1;
      if (next > this.pages) {
        this.finished = true;
        return;
      }
      this.loadingMore = true;
      await this.loadRecords(next, true);
      this.loadingMore = false;
    },
    onScroll(e) {
      const el = e.target;
      if (!el) return;
      const threshold = 20;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
        this.loadMore();
      }
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped>
.wallet-bill-page { padding: 20px; }
.summary { display: flex; gap: 16px; margin-bottom: 16px; }
.summary-card { flex: 1; }
.summary-item { display:flex; align-items:center; justify-content:space-between; }
.summary-item .label { color:#909399; font-weight:500; }
.summary-item .value { font-size:22px; font-weight:700; color:#303133; }
.bill-list { margin-top: 8px; }
.bill-scroll { max-height: calc(100vh - 240px); overflow-y: auto; }
.list-footer { display:flex; justify-content:center; padding: 10px; color:#909399; }
.expense { color: #F56C6C; }
.income { color: #67C23A; }
</style>
